import React from "react";
import { Redirect } from "react-router-dom";

import { CustomerRecapInformationsProps, CustomerRecapInformationsState } from "./models";

import { withSnackbar, WithSnackbarProps } from "notistack";

import { Customer, CustomerStatus, Document, Person, UserRole } from "../../../pages/models";
import CustomerOtherDataForm from "../customer-other-data-form/customer-other-data-form";

import CustomerForm from "../customer-form/customer-form";

import { t, Trans } from "@lingui/macro";
import { Button, Dialog, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Typography } from "@mui/material";

import { CustomersService } from "../../../services/customers.service";
import CustomerRelatedPerson from "./customer-related-person/customer-related-person";

import { ConfirmDialog, ErrorResponse, Loading, RestResponse } from "@sinossi/mates-react-library";
import { SessionService } from "../../../services/session.service";
import SelectedWorkerModal from "../selected-worker-modal/selected-worker-modal";
import UploadDocumentWorkerModal from "../upload-document-worker-modal/upload-document-worker-modal";

import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DownloadIcon from "@mui/icons-material/Download";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LinkIcon from "@mui/icons-material/Link";
import { PersonService } from "../../../services/person.service";
import { DocumentService } from "../../../services/document.service";

class CustomerRecapInformations extends React.Component<CustomerRecapInformationsProps & WithSnackbarProps, CustomerRecapInformationsState> {
    constructor(props: any) {
        super(props);

		this.state = {
			success: false,
			isUploadDocumentModalOpen: false,
			isSelectedWorkerModalOpen: false,
			selectedWorker: null,
			currentUser: null,
			loading: false,
			confirmDeleteDialogShow: false,
			personToDelete: null,
			actionsMenuAnchor: null,
			confirmDeleteDocumentDialogShow: false,
			documentToDelete: null,
			documentToDeletePerson: null,
			documentUploadTargetPerson: null
		};
	}

    getUserErrorCallback = () => {
        this.props.enqueueSnackbar(t({
            id: "cri-error-get-user",
            message: "Si è verificato un errore durante l'ottenimento dell'utenza di lavoro"
        }), {
            variant: "error",
        });
    };

    getUserSuccessCallback = () => {

        let currentUserString = window.sessionStorage.getItem("currentUser");
        let currentUser: any = null;

        if (currentUserString != null) {
            currentUser = JSON.parse(currentUserString);
        }

        this.setState(() => ({
            currentUser: currentUser
        }));
    };


    componentDidMount() {

        this.setState(() => ({ selectedWorker: this.props.customer?.worker }));

        SessionService.getCurrentUser(this.getUserSuccessCallback, this.getUserErrorCallback)
    }

    private verifyCustomer = () => {
        CustomersService.verifyCustomer(this.props.customer!.id, true, this.verifyCustomerCallback);
    };

    private dontVerifyCustomer = () => {
        CustomersService.verifyCustomer(this.props.customer!.id, false, this.verifyCustomerCallback);
    };

    private verifyCustomerCallback = (response: RestResponse<Customer, ErrorResponse>) => {

        if (!response.hasError()) {
            this.setState(() => ({ success: true }));
        } else {
            this.props.enqueueSnackbar(t({
                id: "cri-error-verifiy",
                message: "Si è verificato un errore durante l'aggiornamento della verifica del cliente"
            }), {
                variant: "error",
            });
        }
    };

    private uploadSuccess = (response: any) => {

        this.setState(() => ({ isUploadDocumentModalOpen: false, loading: false }));

        this.props.getCustomer();
    };

    private uploadError = (response: any) => {

        this.setState(() => ({ loading: false }));

        this.props.enqueueSnackbar(t({
            id: "cri-error-upload",
            message: "Si è verificato un errore durante il caricamento del documento"
        }), {
            variant: "error",
        });
    };

    uploadDocumentClose = (document: any) => {
		const personTarget = this.state.documentUploadTargetPerson;

        this.setState(() => ({
			isUploadDocumentModalOpen: false,
			documentUploadTargetPerson: null
		}));

        if (!document) {
            return;
        }

		const referencedEntityId = personTarget?.id ?? this.props.customer?.id;

		if(!referencedEntityId) {
			this.props.enqueueSnackbar(t({
				id: "cri-upload-document-target-error",
				message: "Impossibile individuare il soggetto per il caricamento del documento"
			}), {
				variant: "error",
			});
			return;
		}

        this.setState(() => ({ loading: true }));

        document.documentType = document.documentType.type;
        document.referencedEntityId = referencedEntityId;

        CustomersService.uploadDocument(document.file, document, this.uploadSuccess, this.uploadError);
    };

    openUploadDocumentModal = () => {
        this.setState(() => ({
			isUploadDocumentModalOpen: true,
			documentUploadTargetPerson: null
		}));
    };

	private openPersonUploadDocumentModal = (person: Person) => {
		if(!person?.id) {
			this.props.enqueueSnackbar(t({
				id: "cri-upload-document-missing-person",
				message: "Non è possibile caricare documenti per una persona senza identificativo"
			}), {
				variant: "error",
			});
			return;
		}

		this.setState(() => ({
			isUploadDocumentModalOpen: true,
			documentUploadTargetPerson: person
		}));
	};

    updateWorkerCallback = (response: any) => {

        if (!response.hasError()) {
            this.setState(() => ({ selectedWorker: response.data.worker }));
        } else {
            this.props.enqueueSnackbar(t({
                id: "cri-error-update-worker",
                message: "Si è verificato un errore durante la modifica del professionista"
            }), {
                variant: "error",
            });
        }
    }

    checkUserCanVerify = (): boolean => {

        if (!this.state.currentUser)
            return false;

        if (this.state.currentUser.role === UserRole.SECRETARY)
            return false;

        if (this.state.currentUser.id !== this.props.customer?.worker.id)
            return false;

        return (this.props.customer?.status === CustomerStatus.INSERTED_DATA || this.props.customer?.status === CustomerStatus.EXPIRED_ADV);
    }


    checkUserCanChangeWorker = (): boolean => {


        if (!this.state.currentUser)
            return false;

        if (this.state.currentUser.role === UserRole.WORKER)
            return false;

        return true;
    }

    selectedWorkerClose = (workerId: any) => {

        this.setState(() => ({
            isSelectedWorkerModalOpen: false
        }));

        if (workerId && workerId !== this.state.selectedWorker?.id) {
            CustomersService.updateWorker(this.props.customer?.id, workerId, this.updateWorkerCallback);
        }
    };

    openSelectedWorkerModal = () => {
        this.setState(() => ({ isSelectedWorkerModalOpen: true }));
    };

    resendOnboardingMail = () => {
        CustomersService.resendOnboardingMail(this.props.customer?.id, this.resendMailCallback);
    }

    manualConfirmDocuments = () => {
        CustomersService.manualConfirmDocuments(this.props.customer?.id, this.manualConfirmDocumentsCallback);
    }

    canDownloadIdentificationDocument = (): boolean => {
        if (!this.props.customer?.status)
            return false;

		return [
			CustomerStatus.VERIFIED,
			CustomerStatus.NOT_VERIFIED,
			CustomerStatus.WAITING_DOCUMENTS,
			CustomerStatus.EXPIRED_ADV,
			CustomerStatus.INSERTED_DATA
		].includes(this.props.customer.status);
	}

	downloadIdentificationDocument = () => {
		if (!this.props.customer?.id)
			return;

		CustomersService.downloadIdentificationDocument(this.props.customer.id);
	}

	private openActionsMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		const anchor = event.currentTarget;
		this.setState(() => ({ actionsMenuAnchor: anchor }));
	};

	private closeActionsMenu = () => {
		this.setState(() => ({ actionsMenuAnchor: null }));
	};

	private copyFinalizeLink = async () => {
		const customerId = this.props.customer?.id;
		const authCode = this.props.customer?.additionalInfo?.authCode;

		if(!customerId || !authCode) {
			this.props.enqueueSnackbar(t({
				id: "cri-copy-finalize-link-error",
				message: "Impossibile generare il link di compilazione"
			}), {
				variant: "error",
			});
			return;
		}

		const baseUrl = process.env.REACT_APP_BASE_URL ?? window.location.origin;
		const link = `${baseUrl}/end/${customerId}?authString=${encodeURIComponent(authCode)}`;

		try {
			if(navigator.clipboard && window.isSecureContext) {
				await navigator.clipboard.writeText(link);
			} else {
				const textArea = document.createElement("textarea");
				textArea.value = link;
				textArea.style.position = "fixed";
				textArea.style.opacity = "0";
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();
				document.execCommand("copy");
				document.body.removeChild(textArea);
			}

			this.props.enqueueSnackbar(t({
				id: "cri-copy-finalize-link-success",
				message: "Link di compilazione copiato negli appunti"
			}), {
				variant: "success",
			});
		} catch (error) {
			this.props.enqueueSnackbar(t({
				id: "cri-copy-finalize-link-error",
				message: "Impossibile generare il link di compilazione"
			}), {
				variant: "error",
			});
		}
	};

	private copyDataEntryLink = async () => {
		const efestoProcessId = this.props.customer?.efestoProcessId;
		const dataEntryBaseLink = process.env.REACT_APP_DATA_ENTRY_LINK;

		if(!efestoProcessId || !dataEntryBaseLink) {
			this.props.enqueueSnackbar(t({
				id: "cri-copy-data-entry-link-error",
				message: "Impossibile generare il link di identificazione"
			}), {
				variant: "error",
			});
			return;
		}

		const normalizedBaseLink = dataEntryBaseLink.endsWith("/")
			? dataEntryBaseLink.slice(0, -1)
			: dataEntryBaseLink;

		const link = `${normalizedBaseLink}/start?token=${encodeURIComponent(efestoProcessId)}`;

		try {
			if(navigator.clipboard && window.isSecureContext) {
				await navigator.clipboard.writeText(link);
			} else {
				const textArea = document.createElement("textarea");
				textArea.value = link;
				textArea.style.position = "fixed";
				textArea.style.opacity = "0";
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();
				document.execCommand("copy");
				document.body.removeChild(textArea);
			}

			this.props.enqueueSnackbar(t({
				id: "cri-copy-data-entry-link-success",
				message: "Link di identificazione copiato negli appunti"
			}), {
				variant: "success",
			});
		} catch (error) {
			this.props.enqueueSnackbar(t({
				id: "cri-copy-data-entry-link-error",
				message: "Impossibile generare il link di identificazione"
			}), {
				variant: "error",
			});
		}
	};

	private deletePerson = (person: Person) => {
		if(!person.id) {
			return;
		}

		this.setState(() => ({
			confirmDeleteDialogShow: true,
			personToDelete: person
		}));
	};

	private closeDeleteDialog = () => {
		this.setState(() => ({
			confirmDeleteDialogShow: false,
			personToDelete: null
		}));
	};

	private confirmDeletePerson = () => {
		const person = this.state.personToDelete;
		if(!person?.id) {
			this.closeDeleteDialog();
			return;
		}

		this.setState(() => ({ loading: true }));

		PersonService.deletePerson(person.id, this.deletePersonCallback);
	};

	private deletePersonCallback = (response: RestResponse<Person, ErrorResponse>) => {
		this.setState(() => ({ loading: false }));
		this.closeDeleteDialog();

		if(response.hasError()) {
            this.props.enqueueSnackbar(t({
                id: "cri-delete-person-error",
                message: "Si è verificato un errore durante l'eliminazione della persona"
            }), {
                variant: "error",
            });
            return;
        }

        this.props.enqueueSnackbar(t({
            id: "cri-delete-person-success",
            message: "Persona eliminata correttamente"
        }), {
            variant: "success",
        });

		window.location.reload();
    };

	private requestDeleteDocument = (document: Document, person?: Person) => {
		this.setState(() => ({
			documentToDelete: document,
			documentToDeletePerson: person ?? null,
			confirmDeleteDocumentDialogShow: true
		}));
	};

	private closeDeleteDocumentDialog = () => {
		this.setState(() => ({
			confirmDeleteDocumentDialogShow: false,
			documentToDelete: null,
			documentToDeletePerson: null
		}));
	};

	private confirmDeleteDocument = () => {
		const documentId = this.state.documentToDelete?.id;
		if(!documentId) {
			this.closeDeleteDocumentDialog();
			return;
		}

		this.setState(() => ({ loading: true }));

		DocumentService.deleteDocument(documentId)
			.then(response => {
				if(!response.ok) {
					throw response;
				}
				this.handleDeleteDocumentSuccess();
			})
			.catch(error => {
				this.handleDeleteDocumentError(error);
			});
	};

	private handleDeleteDocumentSuccess = () => {
		this.setState(() => ({
			loading: false,
			confirmDeleteDocumentDialogShow: false,
			documentToDelete: null,
			documentToDeletePerson: null
		}));

		this.props.enqueueSnackbar(t({
			id: "cri-delete-document-success",
			message: "Documento eliminato correttamente"
		}), {
			variant: "success",
		});

		window.location.reload();
	};

	private handleDeleteDocumentError = async (error: Response | any) => {
		let message = t({
			id: "cri-delete-document-error",
			message: "Si è verificato un errore durante l'eliminazione del documento"
		});

		if(error instanceof Response) {
			try {
				const data = await error.json();
				if(data?.message) {
					message = data.message;
				}
			} catch {
				try {
					const text = await error.text();
					if(text) {
						message = text;
					}
				} catch {
					// ignore
				}
			}
		}

		this.setState(() => ({
			loading: false,
			confirmDeleteDocumentDialogShow: false,
			documentToDelete: null,
			documentToDeletePerson: null
		}));

		this.props.enqueueSnackbar(message, {
			variant: "error",
		});
	};

	private deleteDocumentDialogMessage = () => {
		const baseMessage = t({
			id: "cri-delete-document-description",
			message: "Il documento selezionato verrà eliminato. L'operazione non è reversibile."
		});

		if(!this.state.documentToDelete) {
			return baseMessage;
		}

		const details: string[] = [];

		if(this.state.documentToDelete.fileName) {
			details.push(this.state.documentToDelete.fileName);
		} else if(this.state.documentToDelete.type) {
			details.push(this.state.documentToDelete.type.toString());
		}

		if(this.state.documentToDeletePerson) {
			const person = this.state.documentToDeletePerson;
			const fullName = `${person.name ?? ""} ${person.surname ?? ""}`.trim();
			if(fullName.length > 0) {
				details.push(fullName);
			}
		}

		const prefix = details.join(" - ");

		return prefix ? `${prefix} - ${baseMessage}` : baseMessage;
	};

    private resendMailCallback = (response: any) => {

        if (response.status() !== 200) {
            this.props.enqueueSnackbar(t({
                id: "cri-error-resend-onboarding-mail",
                message: "Si è verificato un errore durante l'invio dell'email"
            }), {
                variant: "error",
            });
        } else {
            this.props.enqueueSnackbar(t({
                id: "cri-success-resend-onboarding-mail",
                message: "L'email è stata inviata"
            }), {
                variant: "success",
            });
        }
    };

    private manualConfirmDocumentsCallback = (response: any) => {

        if (response.status() !== 200) {
            this.props.enqueueSnackbar(t({
                id: "cri-error-approve-documents",
                message: "Si è verificato un errore durante la conferma dell'inserimento dati"
            }), {
                variant: "error",
            });
        } else {
            this.props.enqueueSnackbar(t({
                id: "cri-success-confirm-data",
                message: "Dati confermati correttamente"
            }), {
                variant: "success",
            });

            window.location.reload();
        }
    };

		render() {
		const availableActions: Array<{
			id: string;
			onClick: () => void | Promise<void>;
			label: React.ReactNode;
			icon: React.ReactNode;
		}> = [];

		if(this.props.customer?.status === CustomerStatus.CREATED) {
			availableActions.push({
				id: "copy-data-entry-link",
				onClick: this.copyDataEntryLink,
				label: <Trans id="cri-copy-data-entry-link">Copia link di identificazione</Trans>,
				icon: <LinkIcon fontSize="small" />
			});
		}

		if((this.props.customer?.status === CustomerStatus.WAITING_DOCUMENTS
			|| this.props.customer?.status === CustomerStatus.INSERTED_DATA) &&
			this.props.customer?.id && this.props.customer?.additionalInfo?.authCode) {
			availableActions.push({
				id: "copy-finalize-link",
				onClick: this.copyFinalizeLink,
				label: <Trans id="cri-copy-finalize-link">Copia link inserimento documenti</Trans>,
				icon: <ContentCopyIcon fontSize="small" />
			});
		}


		if(this.canDownloadIdentificationDocument()) {
			availableActions.push({
				id: "download-identification",
				onClick: this.downloadIdentificationDocument,
				label: <Trans id="cri-download-built-document">Scarica documento identificazione</Trans>,
				icon: <DownloadIcon fontSize="small" />
			});
		}

		if(this.props.customer?.status !== CustomerStatus.VERIFIED) {
			availableActions.push({
				id: "resend-mail",
				onClick: this.resendOnboardingMail,
				label: <Trans id={"cri-resend-mail"}>Rinvio email di identificazione</Trans>,
				icon: <ScheduleSendIcon fontSize="small" />
			});
		}

		if(this.props.customer?.status === CustomerStatus.WAITING_DOCUMENTS) {
			availableActions.push({
				id: "manual-confirm-docs",
				onClick: this.manualConfirmDocuments,
				label: <Trans id={"cri-confirm-docs"}>Conferma documenti</Trans>,
				icon: <ThumbUpOffAltIcon fontSize="small" />
			});
		}

		if(this.checkUserCanVerify()) {
			availableActions.push({
				id: "dont-verify",
				onClick: this.dontVerifyCustomer,
				label: <Trans id={"cri-not-verify"}>Non verificato</Trans>,
				icon: <ThumbDownOffAltIcon fontSize="small" />
			});
		}

		return (<>
			<Loading show={this.state.loading} />
			<Dialog
				maxWidth={"md"}
				open={this.state.isUploadDocumentModalOpen}>
                <UploadDocumentWorkerModal closeModal={this.uploadDocumentClose} />
            </Dialog>
            <Dialog
                maxWidth={"sm"}
                fullWidth
                open={this.state.isSelectedWorkerModalOpen}>
                <SelectedWorkerModal worker={this.state.selectedWorker} closeModal={this.selectedWorkerClose} />
            </Dialog>
			<ConfirmDialog
				open={this.state.confirmDeleteDialogShow}
				title={t({
					id: "cri-delete-person-confirm",
					message: "Confermi l'eliminazione di questa persona?"
				})}
				message={this.state.personToDelete ? `${this.state.personToDelete.name} ${this.state.personToDelete.surname}` : ""}
				ok={this.confirmDeletePerson}
				cancel={this.closeDeleteDialog}
				okText={t({ id: "cc-delete-confirm-btn", message: "Conferma" })}
				cancelText={t({ id: "cc-delete-cancel-btn", message: "Annulla" })}
			/>
				<ConfirmDialog
					open={this.state.confirmDeleteDocumentDialogShow}
					title={t({
						id: "cri-delete-document-confirm",
						message: "Confermi l'eliminazione del documento selezionato?"
					})}
					message={this.deleteDocumentDialogMessage()}
					ok={this.confirmDeleteDocument}
					cancel={this.closeDeleteDocumentDialog}
					okText={t({ id: "cc-delete-confirm-btn", message: "Conferma" })}
					cancelText={t({ id: "cc-delete-cancel-btn", message: "Annulla" })}
				/>
			{this.state.success && <Redirect to="/verify-success" />}
            <Typography variant="body1"
                sx={{
                    fontWeight: "bold",
                    mb: 3
                }}>
                <Trans id="cri-data">
                    Dati generali del cliente
                </Trans>
            </Typography>
            <CustomerForm customer={this.props.customer} readOnly={true} />
		{this.props.customer?.ownerList?.length !== 0 && <>
                <Typography variant="body1"
                    sx={{
                        fontWeight: "bold",
                        mt: 2,
                        mb: 3
                    }}>
                    <Trans id="cri-owners-data">
                        Dati delle persone di interesse
                    </Trans>
                </Typography>
				{this.props.customer?.ownerList!.map(
					(person) => (<CustomerRelatedPerson
						person={person}
						key={person.id}
						canDelete={this.props.isOnlyShow === false}
						canDeleteDocuments={this.props.isOnlyShow === false}
						onDelete={this.deletePerson}
						onRequestDeleteDocument={this.requestDeleteDocument}
						onUploadDocument={this.props.isOnlyShow === false ? this.openPersonUploadDocumentModal : undefined}
					/>))}
		</>}
            <Typography variant="body1"
                sx={{
                    fontWeight: "bold",
                    mt: 2,
                    mb: 3
                }}>
                <Trans id="cri-customer-other-data">
                    Ulteriori dati del cliente
                </Trans>
            </Typography>
	            <CustomerOtherDataForm
					customer={this.props.customer}
					canDeleteDocuments={this.props.isOnlyShow === false}
					onRequestDeleteDocument={this.requestDeleteDocument}
				/>
            <Button
                onClick={this.openUploadDocumentModal}
                color="primary"
                size={"small"}
                variant="outlined">
                <Trans id={"cri-upload"}>Carica documento aggiuntivo</Trans>
            </Button>
            <>
                <Typography variant="body1"
                    sx={{
                        fontWeight: "bold",
                        mt: 2,
                        mb: 2
                    }}>
                    <Trans id="cri-customer-worker">
                        Professionista
                    </Trans>
                </Typography>
                <Typography variant="body1"
                    sx={{
                        mb: 2,
                    }}>
                    <i>{this.state.selectedWorker?.name} {this.state.selectedWorker?.surname}</i>
                </Typography>
                <Button
                    onClick={this.openSelectedWorkerModal}
                    color="primary"
                    size={"small"}
                    variant="outlined"
                    disabled={!this.checkUserCanChangeWorker()}
                >

                    <Trans id={"cri-selected-worker"}>Cambia professionista di riferimento</Trans>
                </Button>
            </>
            <Stack direction={"row"}
                justifyContent={"flex-end"}
                sx={{
                    mt: 2,
                    width: "100%"
                }}
                spacing={2}>
				<Button
					variant="outlined"
					color="primary"
					endIcon={<ArrowDropDownIcon />}
					onClick={this.openActionsMenu}
					disabled={availableActions.length === 0}>
					<Trans id="cri-actions">Azioni</Trans>
				</Button>
				<Menu
					anchorEl={this.state.actionsMenuAnchor}
					open={Boolean(this.state.actionsMenuAnchor)}
					onClose={this.closeActionsMenu}
					anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
					transformOrigin={{ vertical: "top", horizontal: "right" }}>
					{availableActions.map((action) => (
						<MenuItem
							key={action.id}
							onClick={() => {
								this.closeActionsMenu();
								action.onClick();
							}}>
							<ListItemIcon>
								{action.icon}
							</ListItemIcon>
							<ListItemText primary={action.label} />
						</MenuItem>
					))}
				</Menu>
                {this.checkUserCanVerify() && <Button
                    onClick={this.verifyCustomer}
                    color="primary"
                    variant="contained">
                    <Trans id={"cri-verify"}>Verifica</Trans>
                </Button>}
            </Stack>
        </>);
    }
}

export default withSnackbar(CustomerRecapInformations);
